import React from 'react';
import type { SVGProps } from 'react';

interface TopicIconSvgProps extends SVGProps<SVGSVGElement> {}

export const RelationshipsIcon: React.FC<TopicIconSvgProps> = (props) => (
  <svg viewBox="0 0 24 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.271 6.60254C15.3228 7.69028 16.9113 9.10094 18.4871 9.10094C21.6774 9.10094 23.2819 5.22679 21.0265 2.97145C20.3767 2.3216 19.4789 1.9197 18.4871 1.9197C16.0007 1.9197 13.3515 5.44987 11.6917 7.30543C10.232 8.91905 8.03765 11.0206 5.51409 11.0206C0.621298 11.0206 -1.84519 5.07696 1.61793 1.61385C2.61468 0.617095 3.99235 0.000230414 5.51409 0.000230414C7.65958 0.000230414 9.58122 1.53088 11.0048 2.98346L9.73304 4.42212C8.68029 3.33338 7.09073 1.92072 5.51312 1.92072C2.32283 1.92072 0.71835 5.79487 2.97371 8.05021C3.62357 8.70007 4.52135 9.10197 5.51312 9.10197C8.05152 9.10197 10.7898 5.39878 12.5143 3.48922C13.971 1.91158 16.0785 0 18.4859 0C23.3787 0 25.8452 5.94368 22.3821 9.40679C21.3853 10.4035 20.0076 11.0204 18.4859 11.0204C16.3424 11.0204 14.4218 9.49176 12.9983 8.04102L14.271 6.60254Z"
      fill="currentColor"
    />
  </svg>
);
